module.exports = __webpack_public_path__ + "cc77f32865ec13581c7ed4b354da8732.png";